module.exports = __webpack_public_path__ + "media/images/products/products/h6-8ef4d8abb0f79556182a17ffa0f8be0c.png";